define('pages/campaigns/campaigns_page_view',[
  'backbone',
  'jquery',
  '_',

  'modules/campaigns/campaigns_view',
  'modules/campaigns/campaigns_filter_view',
  'text!./campaigns_page_template.html',
], function (
  Backbone,
  $,
  _,
  WeeklyOffersView,
  WeeklyOffersFilterView,
  WeeklyOffersPageTemplate
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (options) {
      this.weeklyOffersView = new WeeklyOffersView();
      this.subViews.push(this.weeklyOffersView);

      this.weeklyOffersFilterView = new WeeklyOffersFilterView();
      this.subViews.push(this.weeklyOffersFilterView);

      this.render();
      this.renderSubView();

      this.listenTo(
        this.weeklyOffersFilterView.filterModel,
        'change',
        function (model) {
          // Populating zone list
          var fullZoneOption = model.get('zoneOptions').options;
          var fullZoneList = [];

          if (fullZoneOption.length !== 0) {
            _.forEach(model.get('zoneOptions').options, function (o) {
              fullZoneList.push({ value: o.value, text: o.text });
            });
            this.weeklyOffersView.zoneList = fullZoneList;
          }

          // Populating active filter choices
          var activeZoneOption = model.get('zoneOptions').active;
          var searchText = model.get('searchText');

          this.weeklyOffersView.filterParams = {
            campaignPeriod: model.get('campaignPeriod'),
            zoneOptions: activeZoneOption,
            searchText: searchText,
          };

          this.weeklyOffersView.fetchOffers();
        }
      );
    },

    template: _.template(WeeklyOffersPageTemplate),
    subViews: [],
    showInfoText: true,

    events: {
      'click .js-toggle-infotext': 'toggleInfoText',
      'click .js-switch-offer-period': 'switchOfferPeriod',
    },

    toggleInfoText: function () {
      this.showInfoText = !this.showInfoText;

      if (this.showInfoText) {
        this.$('.icon.icon-chevron-up').removeClass('hide');
        this.$('.icon.icon-chevron-down').addClass('hide');
        this.$('.panel-info-text').removeClass('hide');
        this.$('.page-actions').removeClass('is-top');
      } else {
        this.$('.icon.icon-chevron-up').addClass('hide');
        this.$('.icon.icon-chevron-down').removeClass('hide');
        this.$('.panel-info-text').addClass('hide');
        this.$('.page-actions').addClass('is-top');
      }
    },

    render: function () {
      this.$el.html(this.template({ showInfoText: this.showInfoText }));
      return this;
    },

    renderSubView: function () {
      this.$('.campaigns-page-content').html(this.weeklyOffersView.$el);
      this.$('.campaigns-filters-content').html(
        this.weeklyOffersFilterView.$el
      );
    },

    switchOfferPeriod: function (e) {
      var allOfferButton = $(
        'button.js-switch-offer-period[data-offer-period="all"]'
      ).first();
      var ongoingOfferButton = $(
        'button.js-switch-offer-period[data-offer-period="ongoing"]'
      ).first();
      var draftOfferButton = $(
        'button.js-switch-offer-period[data-offer-period="draft"]'
      ).first();
      var upcomingOfferButton = $(
        'button.js-switch-offer-period[data-offer-period="upcoming"]'
      ).first();

      if (e.currentTarget.dataset.offerPeriod === 'all') {
        allOfferButton.addClass('active');
        ongoingOfferButton.removeClass('active');
        upcomingOfferButton.removeClass('active');
        draftOfferButton.removeClass('active');
      } else if (e.currentTarget.dataset.offerPeriod === 'ongoing') {
        allOfferButton.removeClass('active');
        upcomingOfferButton.removeClass('active');
        draftOfferButton.removeClass('active');
        ongoingOfferButton.addClass('active');
      } else if (e.currentTarget.dataset.offerPeriod === 'draft') {
        allOfferButton.removeClass('active');
        upcomingOfferButton.removeClass('active');
        ongoingOfferButton.removeClass('active');
        draftOfferButton.addClass('active');
      }    
      else {
        allOfferButton.removeClass('active');
        ongoingOfferButton.removeClass('active');
        draftOfferButton.removeClass('active');
        upcomingOfferButton.addClass('active');
      }

      this.weeklyOffersView.collection.params = _.extend(this.weeklyOffersView.collection.params, {
        offset: 0
      });

      if (this.weeklyOffersFilterView.filterModel) {
        this.weeklyOffersFilterView.filterModel.set(
          'campaignPeriod',
          e.currentTarget.dataset.offerPeriod
        );
      }
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

